import { nanoid } from 'nanoid';
import { useRef } from 'react';

export function useNanoID() {
  const id = useRef(nanoid());
  return id.current;
}
